<div mat-dialog-header>
  <h1>{{ headline }}</h1>
</div>
<mat-dialog-content #scroll class="dialog-container">
  <form>
    <mat-form-field class="col-12">
      <textarea
        matInput
        name="text"
        required
        [placeholder]="placeholder"
        [(ngModel)]="noteData.text"
      ></textarea>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-checkbox name="pinned" class="col-6" [(ngModel)]="noteData.pinned"
      >Pinned Note</mat-checkbox
    >
    <mat-checkbox name="alert" class="col-6" [(ngModel)]="noteData.alert"
      >Alert Note</mat-checkbox
    >
  </form>
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button mat-raised-button color="accent" (click)="save()">{{
    confirm
  }}</button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
